import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "offline-tab" }
const _hoisted_2 = { class: "tab-header" }
const _hoisted_3 = { class: "tab-header-meta" }
const _hoisted_4 = { class: "tab-count" }
const _hoisted_5 = {
  key: 0,
  class: "header-actions"
}
const _hoisted_6 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_7 = {
  key: 1,
  class: "employee-cards"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "avatar-initials"
}
const _hoisted_10 = { class: "employee-info" }
const _hoisted_11 = { class: "employee-name" }
const _hoisted_12 = { class: "employee-meta" }
const _hoisted_13 = { class: "employee-username" }
const _hoisted_14 = {
  key: 0,
  class: "role-chip"
}
const _hoisted_15 = {
  key: 0,
  class: "employee-actions"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 1,
  class: "form-panel"
}
const _hoisted_19 = { class: "form-panel-header" }
const _hoisted_20 = { class: "form-panel-title" }
const _hoisted_21 = { class: "form-section" }
const _hoisted_22 = { class: "field-row" }
const _hoisted_23 = { class: "field" }
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "field" }
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "field" }
const _hoisted_28 = ["value"]
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "form-section" }
const _hoisted_31 = { class: "photo-row" }
const _hoisted_32 = ["src"]
const _hoisted_33 = {
  key: 1,
  class: "avatar-initials"
}
const _hoisted_34 = { class: "photo-actions" }
const _hoisted_35 = { class: "form-actions" }
const _hoisted_36 = {
  key: 0,
  class: "field-error form-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.employees.length) + " " + _toDisplayString(_ctx.employees.length === 1 ? 'funcionário' : 'funcionários'), 1)
      ]),
      (!_ctx.isAnalyst && !_ctx.showForm)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "btn-new",
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('open-form')))
            }, [...(_cache[10] || (_cache[10] = [
              _createElementVNode("svg", {
                width: "14",
                height: "14",
                viewBox: "0 0 14 14",
                fill: "none"
              }, [
                _createElementVNode("path", {
                  d: "M7 1v12M1 7h12",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round"
                })
              ], -1),
              _createTextVNode(" Novo funcionário ", -1)
            ]))])
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.showForm)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.employees.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[11] || (_cache[11] = [
                _createElementVNode("svg", {
                  width: "40",
                  height: "40",
                  viewBox: "0 0 40 40",
                  fill: "none"
                }, [
                  _createElementVNode("circle", {
                    cx: "20",
                    cy: "14",
                    r: "7",
                    stroke: "var(--ink-muted,#888)",
                    "stroke-width": "2"
                  }),
                  _createElementVNode("path", {
                    d: "M6 36c0-7.732 6.268-14 14-14s14 6.268 14 14",
                    stroke: "var(--ink-muted,#888)",
                    "stroke-width": "2",
                    "stroke-linecap": "round"
                  })
                ], -1),
                _createElementVNode("p", null, "Nenhum funcionário não logado cadastrado.", -1),
                _createElementVNode("p", { class: "empty-sub" }, "Cadastre pessoas para controle interno e uso em presenças.", -1)
              ]))]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employees, (employee) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: employee.id,
                    class: "employee-card"
                  }, [
                    _createElementVNode("div", {
                      class: "employee-avatar",
                      style: _normalizeStyle({ background: _ctx.avatarColor(employee.name) })
                    }, [
                      (employee.photoUrl)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.$resolveUrl(employee.photoUrl),
                            alt: "foto",
                            class: "avatar-img"
                          }, null, 8, _hoisted_8))
                        : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.initials(employee.name)), 1))
                    ], 4),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, _toDisplayString(employee.name), 1),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("span", _hoisted_13, "@" + _toDisplayString(employee.username), 1),
                        (employee.roleName)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(employee.roleName), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (!_ctx.isAnalyst)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("button", {
                            class: "action-btn",
                            type: "button",
                            title: "Editar",
                            onClick: ($event: any) => (_ctx.$emit('edit-employee', employee))
                          }, [...(_cache[12] || (_cache[12] = [
                            _createElementVNode("svg", {
                              width: "15",
                              height: "15",
                              viewBox: "0 0 15 15",
                              fill: "none"
                            }, [
                              _createElementVNode("path", {
                                d: "M10.5 2.5l2 2-8 8H2.5v-2l8-8z",
                                stroke: "currentColor",
                                "stroke-width": "1.4",
                                "stroke-linejoin": "round"
                              })
                            ], -1)
                          ]))], 8, _hoisted_16),
                          _createElementVNode("button", {
                            class: "action-btn action-btn--danger",
                            type: "button",
                            title: "Apagar",
                            onClick: ($event: any) => (_ctx.$emit('delete-employee', employee))
                          }, [...(_cache[13] || (_cache[13] = [
                            _createElementVNode("svg", {
                              width: "15",
                              height: "15",
                              viewBox: "0 0 15 15",
                              fill: "none"
                            }, [
                              _createElementVNode("path", {
                                d: "M3 4h9M6 4V2.5h3V4M5.5 4v7.5h4V4",
                                stroke: "currentColor",
                                "stroke-width": "1.4",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              })
                            ], -1)
                          ]))], 8, _hoisted_17)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.showForm && !_ctx.isAnalyst)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("h3", _hoisted_20, _toDisplayString(_ctx.form.isEditing ? 'Editar funcionário' : 'Novo funcionário não logado'), 1),
            _createElementVNode("button", {
              class: "btn-cancel-link",
              type: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close-form')))
            }, "Cancelar")
          ]),
          _createElementVNode("fieldset", _hoisted_21, [
            _cache[18] || (_cache[18] = _createElementVNode("legend", { class: "form-section-label" }, "Identidade", -1)),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _cache[14] || (_cache[14] = _createElementVNode("label", {
                  class: "field-label",
                  for: "offline-name"
                }, "Nome", -1)),
                _createElementVNode("input", {
                  id: "offline-name",
                  class: "field-input",
                  value: _ctx.form.name,
                  type: "text",
                  placeholder: "Ex: José Pereira",
                  onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateField('name', ($event.target as HTMLInputElement).value)))
                }, null, 40, _hoisted_24)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _cache[15] || (_cache[15] = _createElementVNode("label", {
                  class: "field-label",
                  for: "offline-username"
                }, "Username interno", -1)),
                _createElementVNode("input", {
                  id: "offline-username",
                  class: "field-input",
                  value: _ctx.form.username,
                  type: "text",
                  placeholder: "josepereira",
                  onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateField('username', ($event.target as HTMLInputElement).value)))
                }, null, 40, _hoisted_26)
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _cache[17] || (_cache[17] = _createElementVNode("label", {
                class: "field-label",
                for: "offline-role"
              }, "Cargo", -1)),
              _createElementVNode("select", {
                id: "offline-role",
                class: "field-input field-select",
                value: _ctx.form.roleId,
                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateField('roleId', ($event.target as HTMLSelectElement).value)))
              }, [
                _cache[16] || (_cache[16] = _createElementVNode("option", { value: "" }, "Sem cargo", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (role) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: role.id,
                    value: role.id
                  }, _toDisplayString(role.name), 9, _hoisted_29))
                }), 128))
              ], 40, _hoisted_28)
            ])
          ]),
          _createElementVNode("fieldset", _hoisted_30, [
            _cache[19] || (_cache[19] = _createElementVNode("legend", { class: "form-section-label" }, "Foto", -1)),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", {
                class: "photo-preview",
                style: _normalizeStyle({ background: _ctx.avatarColor(_ctx.form.name || _ctx.form.username || '?') })
              }, [
                (_ctx.form.photoUrl)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.form.photoUrl.startsWith('data:') ? _ctx.form.photoUrl : _ctx.$resolveUrl(_ctx.form.photoUrl),
                      alt: "preview",
                      class: "avatar-img"
                    }, null, 8, _hoisted_32))
                  : (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.initials(_ctx.form.name || _ctx.form.username || '?')), 1))
              ], 4),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("button", {
                  class: "btn-ghost-action",
                  type: "button",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.triggerPhotoInput && _ctx.triggerPhotoInput(...args)))
                }, "Escolher foto"),
                (_ctx.form.photoUrl)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn-ghost-action",
                      type: "button",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateField('photoUrl', '')))
                    }, "Remover"))
                  : _createCommentVNode("", true),
                _createElementVNode("input", {
                  ref: "photoInputRef",
                  class: "hidden-input",
                  type: "file",
                  accept: "image/*",
                  onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onPhotoSelected && _ctx.onPhotoSelected(...args)))
                }, null, 544)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("button", {
              class: "btn-primary-action",
              type: "button",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('save-employee')))
            }, _toDisplayString(_ctx.form.isEditing ? 'Salvar alterações' : 'Cadastrar funcionário'), 1),
            _createElementVNode("button", {
              class: "btn-ghost-action",
              type: "button",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('close-form')))
            }, "Cancelar")
          ]),
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("p", _hoisted_36, _toDisplayString(_ctx.error), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}